<template>
  <div :class="`mark mark--new${mark.handleNext ? 'mark--next' : ''}`">
    <div
      :class="`mark__flag mark__flag--${mark.type}`"
      :style="{left: `${mark.x}%`, top: `${mark.y}%`}"
      @click="handleClick"
    >
      <span class="mark__icon">
        <img :src="`${mark.image}`" />
      </span>
      <span class="mark__text" v-html="mark.label[lang]" />
    </div>
    <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
      <div class="overlay" v-if="showPopup"></div>
    </transition>
    <transition enter-active-class="animated flippInY" leave-active-class="animated flippOutY">
      <Popup v-if="showPopup" :data="mark" @close-popup="showPopup=false" />
    </transition>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import Popup from "@/components/Popup";

export default {
  name: "mark-item-next",

  data() {
    return {
      showPopup: false
    };
  },

  props: {
    mark: Object
  },

  computed: {
    ...mapState(["lang", "infographicsScenes"])
  },

  methods: {
    ...mapMutations(["setScene"]),
    handleClick: function(e) {
      if (this.mark.handleNext) {
        const nextSceneId = this.infographicsScenes.find(
          s => s._id && s._id === this.mark.handleNext
        );

        this.$router.push(
          `/${nextSceneId._id}`
        );

        return;
      } else {
        const win = window.open(this.mark.link[this.lang], "_blank");
        win.focus();
      }
    }
  },

  components: {
    Popup
  }
};
</script>

<style lang="scss" scoped>
.overlay {
  position: fixed;
  min-width: 1920px;
  min-height: 1080px;
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  background: rgba(black, 0.5);
  z-index: 1;
}

.mark {
  &--new,
  &--next {
    .mark__flag {
      cursor: pointer;
    }
  }

  &__flag {
    position: absolute;
    top: 0;
    left: 0;
    display: table;
    // min-height: 105px;
    // height: 105px;
    min-width: 330px;
    word-wrap: break-word;
    text-align: left;
    font-size: 27px;
    color: #004169;
    font-weight: 500;
    padding: 0 35px 0 130px;
    background: url("~@/assets/flag-inner.svg") no-repeat right center;
    background-size: cover;
    white-space: nowrap;
    // cursor: pointer;
    z-index: 7;

    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 115px;
      height: 105px;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transition: 0.3s;
      transform-origin: center right;
      transform: translate(-50%);
    }

    &:hover,
    &:focus {
      &::before {
        transform: translateX(-50%) scale(1.1);
      }
    }

    &:hover .mark__icon img {
      transform: scale(1.1);
    }
  }

  &__text {
    display: table-cell;
    height: 105px;
    vertical-align: middle;
    padding-top: 15px;
    padding-bottom: 15px;
  }

  &__icon {
    position: absolute;
    left: 0;
    top: 50%;
    width: 115px;
    height: 105px;
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    transition: 0.3s;
    // transform-origin: center right;
    // transform: translate(-50%);
    left: -60px;
    top: 50%;
    margin-top: -52.5px;


    img {
      height: 100%;
      width: 100%;
      object-fit: contain;
      transition: 0.3s ease;
    }
  }

  &--new {
    .mark__flag {
      background: none;
      background-color: #7a9cb5;
      color: #fff;
      padding: 0 35px 0 60px;
      min-width: auto;
      // max-width: 420px;
      white-space: nowrap;
    }
  }
}

@keyframes flipInY {
  from {
    transform: perspective(1500px) rotate3d(0, 1, 0, 90deg);
    animation-timing-function: ease-out;
    opacity: 0;
  }

  70% {
    transform: perspective(2000px) rotate3d(0, 1, 0, -15deg);
    opacity: 1;
  }

  to {
    transform: perspective(2000px);
  }
}

.flippInY {
  backface-visibility: visible !important;
  animation-name: flipInY;
}

@keyframes flipOutY {
  from {
    transform: perspective(2000px);
  }

  30% {
    transform: perspective(2000px) rotate3d(0, 1, 0, -15deg);
    opacity: 1;
  }

  to {
    transform: perspective(2000px) rotate3d(0, 1, 0, 90deg);
    opacity: 0;
  }
}

.flippOutY {
  animation-duration: 0.75s;
  backface-visibility: visible !important;
  animation-name: flipOutY;
}
</style>
